import React from 'react'
import Form from '@rjsf/mui'
import validator from '@rjsf/validator-ajv8'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { JSONSchema7 } from 'json-schema'
import ButtonDialog from '../shared/ButtonDialog'
import { EditProps } from '../shared/EditProps'
import { useAuth } from '../../context/useAuth'
import WaterIcon from '@mui/icons-material/Water'
import AirIcon from '@mui/icons-material/Air'
import EditIcon from '@mui/icons-material/Edit'

export default function EditHeatPumpSource({ disabled, schema, value, setData }: EditProps) {
  const { name } = useParams()
  const { csrf } = useAuth()
  const [open, setOpen] = React.useState(false)

  return (
    <ButtonDialog
      disabled={disabled}
      title={`Edit Heat Pump Source`}
      icon={value.type_ === 'water' ? <WaterIcon /> : <AirIcon />}
      iconButton={<EditIcon />}
      content={
        <Form
          onSubmit={async (e) => {
            try {
              const res = await axios.put(
                `${process.env.REACT_APP_API}/${name}/heatpumpsource/${value.name}`,
                JSON.stringify(e.formData),
                {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrf,
                  },
                  withCredentials: true,
                }
              )
              setData(res.data)
              setOpen(false)
            } catch (err) {
              console.log('err:', err)
            }
          }}
          validator={validator}
          schema={schema as JSONSchema7}
          formData={value}
        />
      }
      open={open}
      setOpen={setOpen}
    />
  )
}
